import React from "react";
import "./Footer.scss";

const Footer = () => {
  return <footer>ⓒ 2023. EQBR Holdings all rights reserved.</footer>;
};

export default Footer;
